import createActionTypes from './createActionTypes';

export const namespace = 'DIALOG';

export const types = createActionTypes(namespace, [
  'OPEN_DIALOG',
  'CLOSE_DIALOG',
  'INIT_DIALOG',
  'FETCH_DIALOG_CONTENT',
  'SET_CONTENT',
]);

export const open = () => ({
  type: types.OPEN_DIALOG,
});

export const close = () => ({
  type: types.CLOSE_DIALOG,
});

export const initDialog = (title, content) => ({
  type: types.INIT_DIALOG,
  payload: {
    title,
    content,
  },
});

export const fetchContent = (url) => ({
  type: types.FETCH_DIALOG_CONTENT,
  payload: {
    url,
  },
});

export const setContent = (content) => ({
  type: types.INIT_DIALOG,
  payload: {
    content,
  },
});
